import React from 'react'
import '../styles/Portfolio.css';
import data from '../Portfolio'



function Portfolio() {
  return (
    <div className='portfolio-a'>
        <div className='portfolio'>
            <div className='text'>
                <h4>My Recent Work</h4>
                <h2 className='a'>Portfolio</h2>
            </div>
                
                <div className='portfolio_container'>
                    { data.map((port) => {
                        return (
                        <div className='portfolio_item' key={port.id}>
                            <div className="portfolio_item_img">
                                <img src={port.img} alt={port.title} />
                            </div>
                            <h3>{port.title}</h3>
                            <div className='portfolio_item-cta'>
                                    <button className='btn'><a href={port.git} target='_blank'>Github</a></button>
                                    <button className='btn'><a href={port.demo} target='_blank'>Live Demo</a></button>
                            </div>
                        </div>
                        )
                    })
                        
                        }
                </div>
        </div>
    </div>
  )
}

export default Portfolio;